//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { MobilityScooterHireLargeSVG } from './svg'

interface MobilityScooterHireLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const MobilityScooterHireLargeIcon: React.FC<MobilityScooterHireLargeIconProps> = forwardRef<
  MobilityScooterHireLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={MobilityScooterHireLargeSVG}
    sx={sx}
  />
))
